import { StripePrice } from './StripeState'
import { StripeType } from './StripeType'

export const definseStripePriceId = (priceId: Array<string>) => {
  return { type: StripeType.SET_PRICE_ID, payload: { priceId } }
}

export const definseStripePrice = (price: Array<StripePrice>) => {
  return { type: StripeType.SET_PRICE, payload: { price } }
}
